// Inside the ASYS phone app (its web view says ASYSMobile in the user
// agent; ?in_app=1 does the same in a browser, for the app's web preview).
// The app has its own tabs and header, so pages show without the web header
// and sidebar; and plans aren't changed here (the app stores' rules), so
// the plan page only shows the plan.
const KEY = 'asys:in-app'

function detect() {
  try {
    if (/ASYSMobile/i.test(navigator.userAgent || '')) return true
    if (new URLSearchParams(window.location.search).get('in_app') === '1') {
      sessionStorage.setItem(KEY, '1')
      return true
    }
    return sessionStorage.getItem(KEY) === '1'
  } catch {
    return false
  }
}

export const IN_APP = typeof window !== 'undefined' && detect()

// On <html>, so the in-app styles reach windows opened outside the page
// layout (dialogs) too.
if (IN_APP) document.documentElement.classList.add('in-app')
